// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"89":"18702c29","294":"65867d81","777":"36454f15","953":"d120a739"}[chunkId] + ".js";
};